module.exports = __webpack_public_path__ + "statics/img/FeaturedCases-4.f0a60eee.png";